/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/styles/tailwind.base.css'
import './src/styles/tailwind.components.css'
import './src/styles/index.css'
import './src/styles/tailwind.utilities.css'

import React from 'react'

import { LayoutProvider } from './src/providers/LayoutProvider'
export const wrapRootElement = ({ element }) => (
  <LayoutProvider>{element}</LayoutProvider>
)

export const onRouteUpdate = ({ location, prevLocation }) => {
  // The base code already tracks the initial page load.
  if (
    process.env.NODE_ENV !== 'production' ||
    !prevLocation ||
    typeof window.fbq !== 'function'
  ) {
    return
  }

  // In-page anchors do not represent a new page view.
  if (
    location.pathname === prevLocation.pathname &&
    location.search === prevLocation.search
  ) {
    return
  }

  window.fbq('track', 'PageView')
}
